import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/desktop/25_new_york/25_new_york"
 * Contains 1 texture(s)
 */
export class Desktop25NewYorkAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/desktop/25_new_york/25_new_york';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '25_new_york.jpg'
    ] as const;
}
